import { ChangeDetectorRef, Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-instance-confirmation',
    templateUrl: './instance-confirmation.component.html',
    styleUrls: ['./instance-confirmation.component.scss'],
    standalone: false
})
export class InstanceConfirmationComponent {
    editMode: boolean = false;
    message: string = '';

    constructor(
        private ngbActiveModal: NgbActiveModal,
        private cd: ChangeDetectorRef
    ) { }

    closeModal() {
        this.ngbActiveModal.close(false);
    }

    okClick() {
        this.ngbActiveModal.close(true);
    }
}
